import { customSeriesDefaultOptions, CustomSeriesOptions, LineStyle, LineType, LineWidth } from 'lightweight-charts'
import { buyColor, red } from '../../../../assets/colors'

export interface KagiSeriesOptions extends CustomSeriesOptions {
    upColor: string,
    downColor: string,
    projectionUpColor: string,
    projectionDownColor: string,
    color: string,
    lineType: LineType,
    lineWidth: LineWidth,
    lineStyle: LineStyle,
    boxMethod: 'atr' | 'percentage' | 'traditional',
    atrLength: number,
    percentageLTP: number,
    reversalAmount: number
}

export const defaultKagiOptions: KagiSeriesOptions = {
    ...customSeriesDefaultOptions,
    upColor: buyColor,
    downColor: red,
    projectionUpColor: "#a9dcc3",
    projectionDownColor: "#f5a6ae",
    color: buyColor,
    lineType: LineType.Simple,
    lineWidth: 4,
    lineStyle: LineStyle.Solid,
    boxMethod: 'traditional',
    atrLength: 14,
    percentageLTP: 1,
    reversalAmount: 2
}